<nav class="horizontal-menu">
	<div class="show-block">
		<a mat-raised-button [routerLink]="'/' + urlLinkEnum.stockManager()">
			<mat-icon>bar_chart</mat-icon>
			{{ 'admin_console.stock_management' | translate }}
		</a>

		<a class="last-btn" mat-raised-button [routerLink]="'/' + urlLinkEnum.salesOverview()">
			<mat-icon>bar_chart</mat-icon>
			{{ 'stock_management.title' | translate }}
		</a>
	</div>
	<!-- <a mat-raised-button>
    <mat-icon>settings</mat-icon>
    {{ 'admin_console.machine' | translate }}
  </a>-->
	<div class="show-block">
		<a mat-raised-button [routerLink]="'/' + urlLinkEnum.timeSettings()">
			<mat-icon>settings</mat-icon>
			{{ 'admin_console.time_settings' | translate }}
		</a>

		<a mat-raised-button (click)="logout()" class="out-color last-btn">
			<mat-icon>logout</mat-icon>
			{{ 'common.logout' | translate }}
		</a>
	</div>
	<!-- <div class="show-block">
    <a
      mat-raised-button
      class="button-delivery"
      (click)="openDialogSetTime(deliveryProvider.WOLT)">
      <div>
        <img src="../assets/wolt.svg" class="logo" height="18" />
        <h3> {{ 'admin_console.smoothr_delivery' | translate }}
        </h3>
      </div>
    </a>

    <a
      class="last-btn button-delivery"
      mat-raised-button
      (click)="openDialogSetTime(deliveryProvider.UBER)">
      <div>
        <img src="../assets/uber_eats.png" class="logo" height="18" />
        <h3> {{ 'admin_console.smoothr_delivery' | translate }}
        </h3>
      </div>
    </a>
  </div> -->
	<!-- <div class="show-block">
    <a
      mat-raised-button
      class="button-delivery"
      (click)="updateSmoothrOffsetsType()">
      <div>
        <img src="../../../assets/tresen/smoothr_logo.svg" alt="logo" class="logo">
        <h3>
          {{ 'admin_console.smoothr_delivery' | translate }}
        </h3>
      </div>
    </a>
  </div> -->
	<!-- <a mat-raised-button [routerLink]="'/' + urlLinkEnum.openingHours()">
    <mat-icon>access_time</mat-icon>
    {{ 'admin_console.opening_hours' | translate }}
  </a> -->
	@if (venueValue$ | async; as venue) {
	<div class="show-block">
		<a mat-raised-button class="button-delivery" (click)="updateUber()" *ngIf="checkIfSetupOrderProviders(venue, 'uber_eat')">
			<div>
				<img src="/assets/uber_eats.png" class="logo" height="15" alt="uber_logo" />
				@if (isVenueOpen$ | async) { @if (isUberEatsActiveInVenue$ | async; as valueWolt) {
				<h3 class="green">{{ 'common.online' | translate }}</h3>
				} @else {
				<h3 class="red">
					{{ 'common.offline' | translate }}
					<p *ngIf="venue.externalOrderProviders?.uberEats?.snoozed">
						bis:
						{{ venue.externalOrderProviders.uberEats.snoozed | date: 'HH:mm dd.MM' }}
					</p>
				</h3>
				} } @else {
				<h3 class="red">{{ 'common.closed' | translate }}</h3>
				}
			</div>
		</a>

		<a
			*ngIf="checkIfSetupOrderProviders(venue, 'self-delivery') && hasDeliveryHours(venue)"
			mat-raised-button
			class="button-delivery last-btn"
			(click)="updateSmoothrWithParams(venue, preorderTypeEnum.DELIVERY)"
		>
			<div>
				<h3 class="title-text">
					{{ 'admin_console.self_delivery' | translate }}
				</h3>
				@if (isVenueOpen$ | async) { @if (venue.deliveryEnabled) {
				<h3 class="green">{{ 'common.online' | translate }}</h3>
				} @else {
				<h3 class="red">{{ 'common.offline' | translate }}</h3>
				} } @else {
				<h3 class="red">{{ 'common.closed' | translate }}</h3>
				}
			</div>
		</a>
	</div>
	} @if (venueValue$ | async; as venue) {
	<div class="show-block">
		<a *ngIf="checkIfSetupOrderProviders(venue, 'wolt')" mat-raised-button class="button-delivery last-btn" (click)="updateWolt()">
			<div>
				<img src="../assets/wolt.svg" class="logo" height="18" />
				@if (isVenueOpen$ | async) { @if (isWoltActiveInVenue$ | async; as valueWolt) {
				<h3 class="green">{{ 'common.online' | translate }}</h3>
				} @else {
				<h3 class="red">
					{{ 'common.offline' | translate }} <br />
					<p *ngIf="venue.externalOrderProviders?.wolt?.snoozed">
						bis:
						{{ venue.externalOrderProviders.wolt.snoozed | date: 'HH:mm dd.MM' }}
					</p>
				</h3>
				} } @else {
				<h3 class="red">{{ 'common.closed' | translate }}</h3>
				}
			</div>
		</a>

		<a mat-raised-button class="button-delivery last-btn" (click)="updateSmoothrWithParams(venue, preorderTypeEnum.TAKE_AWAY)">
			<div>
				<h3 class="title-text">
					{{ 'admin_console.self_take_away' | translate }}
				</h3>
				@if (isVenueOpen$ | async) { @if (venue.preorderTakeAway) {
				<h3 class="green">{{ 'common.online' | translate }}</h3>
				} @else {
				<h3 class="red">{{ 'common.offline' | translate }}</h3>
				} } @else {
				<h3 class="red">{{ 'common.closed' | translate }}</h3>
				}
			</div>
		</a>
	</div>
	} @if (venueValue$ | async; as venue) {
	<div class="show-block">
		<a
			*ngIf="checkIfSetupOrderProviders(venue, 'deliveroo')"
			mat-raised-button
			class="button-delivery last-btn"
			(click)="updateDeliveroo()"
		>
			<div>
				<h3 class="title-text">Deliveroo</h3>

				@if (isVenueOpen$ | async) { @if (isDeliverooActiveInVenue$ | async; as valueDeliveroo) {
				<h3 class="green">{{ 'common.online' | translate }}</h3>
				} @else {
				<h3 class="red">
					{{ 'common.offline' | translate }}
					<p *ngIf="venue.externalOrderProviders?.deliveroo?.snoozed">
						bis:
						{{ venue.externalOrderProviders.deliveroo.snoozed | date: 'HH:mm dd.MM' }}
					</p>
				</h3>
				} } @else {
				<h3 class="red">{{ 'common.closed' | translate }}</h3>
				}
			</div>
		</a>
	</div>
	}
	<div class="show-block">
		@if (venue$ | async; as venue) { @if (venue.externalOrderProviders.jet.enabled) {
		<a mat-raised-button class="button-delivery" href="https://restaurants.takeaway.com" target="_blank">
			<div>
				<img src="../assets/lieferando.png" class="logo" height="15" />
				<h3 class="text_small">
					{{ 'admin_console.delivery_info' | translate }}
				</h3>
			</div>
		</a>
		} }

		<a mat-raised-button class="button-delivery last-btn" (click)="turnOnMusic()">
			<div>
				<h3 class="title-text">{{ 'common.sound' | translate }}</h3>
				@if (music$ | async) {
				<h3 class="green">{{ 'common.on' | translate }}</h3>
				} @else {
				<h3 class="red">{{ 'common.off' | translate }}</h3>
				}
			</div>
		</a>
	</div>
	<div class="show-block">
		<a mat-raised-button class="button-delivery last-btn" (click)="toggleShowRefund()">
			<div>
				<h3 class="title-text">{{ 'common.refund' | translate }}</h3>
				@if (refund$ | async) {
				<h3 class="green">{{ 'common.on' | translate }}</h3>
				} @else {
				<h3 class="red">{{ 'common.off' | translate }}</h3>
				}
			</div>
		</a>

		<a mat-raised-button class="button-delivery last-btn" (click)="toggleShowDiscount()">
			<div>
				<h3 class="title-text">{{ 'common.discount' | translate }}</h3>
				@if (discount$ | async) {
				<h3 class="green">{{ 'common.on' | translate }}</h3>
				} @else {
				<h3 class="red">{{ 'common.off' | translate }}</h3>
				}
			</div>
		</a>
	</div>
	<div class="show-block">
		<a mat-raised-button (click)="refreshPage()">
			<mat-icon>autorenew</mat-icon>
			{{ 'admin_console.refresh_page' | translate }}
		</a>
	</div>
</nav>
